import { QueryClient } from '@tanstack/react-query';

/**
 * React Query client configuration
 * Configures default options for queries and mutations
 * Implements Requirements:
 * - 13.1: Real-time UI updates with optimistic updates
 * - 16.4: Data caching prevents redundant API calls
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // OPTIMIZED: Aggressive caching for drag and drop performance
      // Data is considered fresh for 1 minute (reduced from 5)
      staleTime: 60 * 1000, // 1 minute
      
      // Keep cached data for 10 minutes after last use
      gcTime: 10 * 60 * 1000, // 10 minutes
      
      // Retry failed requests once to handle transient network issues
      retry: 1,
      
      // OPTIMIZED: Don't refetch on window focus to prevent interrupting drag operations
      refetchOnWindowFocus: false,
      
      // Refetch when network reconnects to ensure data freshness
      refetchOnReconnect: true,
      
      // OPTIMIZED: Use cached data immediately, don't refetch on mount
      // This makes navigation instant and prevents flickering during drag operations
      refetchOnMount: false,
      
      // Deduplicate requests - multiple components requesting same data share a single request
      networkMode: 'online',
    },
    mutations: {
      retry: 0,
      // OPTIMIZED: Mutations use fire-and-forget pattern for instant UI updates
      // Individual mutations implement specific optimistic logic
      onMutate: async () => {
        // Cancel outgoing refetches to prevent overwriting optimistic update
      },
      onError: () => {
        // Revert optimistic updates on error
      },
      onSettled: () => {
        // Refresh data after mutation completes (in background)
      },
    },
  },
});
